import Vue from 'vue'
import router from '../../router'

export default {
  state: {
    templateList: []
  },
  getters: {
    templateList: state => {
      return state.templateList
    },
    noTemplates: state => {
      return state.templateList.length === 0
    }
  },
  mutations: {
    fetchTemplates (state, templateArray) {
      state.templateList = templateArray
    }
  },
  actions: {
    fetchTemplates ({commit, rootState}) {
      if (!rootState.idToken) { return }
      Vue.axios.get('template_docs', { headers: { Authorization: `Bearer ${rootState.idToken}` } })
        .then(res => {
          commit('fetchTemplates', res.data.template_docs)
        })
    },
    addNewTemplate ({commit, state, rootState}, templateData) {
      if (!rootState.idToken) { return }
      let data = new window.FormData()
      data.append('image', templateData.file, templateData.file.name)
      data.append('title', templateData.title)
      data.append('account_id', templateData.accountId)
      Vue.axios.post('template_docs', data, { headers: {
        Authorization: `Bearer ${rootState.idToken}`,
        'content-type': 'multipart/form-data' }
      })
        .then(res => {
          Vue.toasted.show(this._vm.$i18n.translate('TEMPLATE.MSG_ADDED'))
          router.push('/templates/list')
        }, error => {
          console.log(error)
        })
    },
    removeTemplate ({commit, state, rootState, dispatch}, templateData) {
      if (!rootState.idToken) { return }
      Vue.axios.delete('template_docs/' + templateData.id, { headers: {
        Authorization: `Bearer ${rootState.idToken}` }
      })
        .then(res => {
          dispatch('fetchTemplates')
          Vue.toasted.show(this._vm.$i18n.translate('TEMPLATE.MSG_REMOVED'))
        }, error => {
          console.log(error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/templates.js